/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import parse from 'html-react-parser'
import Chat from '../svgs/Chat'
import Clock from '../svgs/Clock'
import * as styles from './BlogCard.module.scss'
import { read } from '@popperjs/core'

function convertReadingTimeToNumber(readingTime) {
  readingTime = readingTime.replace("Reading Time: ", "");
  readingTime = readingTime.replace(/\D/g, "");
  readingTime = parseInt(readingTime);
  return readingTime;
}

function BlogCard({
  categories,
  title,
  excerpt,
  published_date,
  slug,
  featuredImage,
  blogAuthor,
  reading_time,
  flag
}) {
  if(flag===false)
  {
    reading_time = convertReadingTimeToNumber(reading_time);
  }
  return (
    <div className={`${styles.blogList}`}>
      {featuredImage ? (
        <div className={`${styles.blogListImgContainer}`}>
          <Link className={`${styles.blogListImgLink}`} to={`/blog/${slug}`}>
            <img
              className={`${styles.blogListImg}`}
              src={featuredImage}
              alt={title}
            />
          </Link>
        </div>
      ) : null}
      {categories && categories.length > 0 ? (
        <div
          className={`d-flex align-items-center flex-wrap ${styles.categoryLinkContainer}`}
        >
          {Array.isArray(categories) &&
          categories.map((category, index) => (
            <Link
              className={`${styles.categoryLink}`}
              key={index}
              to={`/blog/category/${category.slug}`}
            >
              {category.name}
              {index >= 0 && categories.length > 0 && index<categories.length-1 ? ',' : null}
            </Link>
          ))}
        </div>
      ) : null}
      {title ? (
        <div className={`${styles.titleContainer}`}>
          <Link className={`${styles.titleLink}`} to={`/blog/${slug}`}>
            <p>{title}</p>
          </Link>
        </div>
      ) : null}
      {excerpt ? <p className={`${styles.blogDec}`}>{parse(excerpt)}</p> : null}
      <div
        className={`d-flex align-items-center ${styles.blogFooterContainer}`}
      >
        {blogAuthor ? <p>{blogAuthor}</p> : null}
        {published_date ? <p>{published_date}</p> : null}
        {/* <div className="d-flex align-items-center">
          <Chat className={`${styles.blogFooterIcon}`} />
          <p>23</p>
        </div> */}
        <div className="d-flex align-items-center">
          <Clock className={`${styles.blogFooterIcon}`} />
          <p>{reading_time}</p>
          <p>min read</p>
        </div>
      </div>
    </div>
  )
}

BlogCard.propTypes = {
  categories: PropTypes.instanceOf(Array),
  title: PropTypes.string,
  excerpt: PropTypes.string,
  published_date: PropTypes.string,
  reading_time: PropTypes.number,
  slug: PropTypes.string,
  featuredImage: PropTypes.string,
  blogAuthor: PropTypes.string,
}

BlogCard.defaultProps = {
  categories: null,
  title: null,
  excerpt: null,
  published_date: null,
  reading_time: "1",
  slug: null,
  featuredImage: null,
  blogAuthor: null,
}

export default BlogCard
